module.exports = __webpack_public_path__ + "img/purse.63067528.png";